module.exports = __webpack_public_path__ + "static/media/ss.18c4a224.png";